import React from "react";
import { Phone, Wrench, MonitorCog, Laptop, Lightbulb } from "lucide-react";
import bg from '../assets/bg.webp'
import IconCard from "../Components/Iconcard";
import HeadingBlock from "../Components/HeadingBlock";
import { Helmet } from "react-helmet";
const Helpdesk = () => {
  const services = [
    {
      icon: <Phone className="w-8 h-8 text-green-600" />,
      title: "Dedicated Support Team",
      description: "Phone and WhatsApp helpline for quick solutions.",
    },
    {
      icon: <Wrench className="w-8 h-8 text-green-600" />,
      title: "Troubleshooting Guidance",
      description: "Step-by-step help for common issues.",
    },
    {
      icon: <MonitorCog className="w-8 h-8 text-green-600" />,
      title: "Software Support",
      description: "Assistance with updates and setup.",
    },
    {
      icon: <Laptop className="w-8 h-8 text-green-600" />,
      title: "Remote Assistance",
      description: "Many problems solved without leaving your farm.",
    },
    {
      icon: <Lightbulb className="w-8 h-8 text-green-600" />,
      title: "Best Practices",
      description: "Tips to keep your drone running efficiently.",
    },
  ];

  return (
    <>
     <Helmet>
        <title>Technical Support</title>

        <meta
          name="description"
          content="At Drone Didi, we provide a dedicated phone and WhatsApp support helpline for quick solutions, we provide troubleshooting guidance, software support, remote assistance and so much more."
        />

        <link
          rel="canonical"
          href="https://dronedidi.co.in/helpdesk"
        />
      </Helmet>
      <section className="relative pt-10">
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-fixed bg-center"
        style={{ backgroundImage: `url(${bg})` }}
      ></div>

      {/* Slanted overlay */}
      <div className="absolute hidden md:block inset-0 bg-black/60 clip-slant"></div>

  {/* Content */}
<div className="relative z-10  px-6 lg:px-20 py-24 flex items-center">
  <div className="text-left text-white max-w-2xl xl:max-w-3xl">
    <h2 className="text-3xl md:text-5xl font-bold leading-tight drop-shadow-[5px_0px_1px_black]">
      Helpdesk – Your Co-Pilot on Call
    </h2>
 
    {/* Closing Note */}
    <div className="mt-10 border-l-4 border-green-400 pl-6 italic text-xl text-gray-100 drop-shadow-[3px_0px_1px_black]">
            <p className="mb-6 bg-green-300 text-green-900 font-bold p-3">“Whenever you’re stuck, we’re just a call away.”</p>

      <p className="italic text-xl text-gray-100 drop-shadow-[3px_0px_1px_black]">
        Technology can sometimes feel complex, but you don’t have to face it alone. Our Technical Support Helpdesk is built especially for Drone Didis, offering simple, friendly, and reliable support whenever you need it.
      </p>
    </div>
  </div>
</div>

    </section>
   
    <div className="bg-gray-50 mb-8">


      {/* Expertise Section */}
      <section className="py-16 px-6 md:px-20">        
  <HeadingBlock
        subtitle="Our Expertise"
        title="Our Expertise at Work for You"
          align="center"

        // highlight="Agency"
      />
           <div className="grid md:grid-cols-2 lg:grid-cols-5 justify-center mx-auto my-8 gap-8">
        {services.map((service, index) => (
          <IconCard
            key={index}
            icon={service.icon}
              // iconPosition="top-right"
                iconPosition="top-left"
  cardBg="bg-[#bde2ca]"      // dark red
  iconBg="bg-[#1e4b39]"          // light blue
  // txtcolor="text-white"
  // iconPosition="top-left"

            title={service.title}
            description={service.description}
            borderGradient="from-green-400 to-green-600"
            // arrowIcon={<ArrowRight className="w-5 h-5 text-green-500" />}
          />
        ))}
      </div>
      </section>
          </div>


      {/* Safety Net Section */}
      <section className="pb-20 px-6 md:px-20 text-center">
          <HeadingBlock
        subtitle="Your Safety Net in the Sky"
        title="Reliable drone support that keeps your farming journey uninterrupted"
          align="center"

        // highlight="Agency"
      />
        <p className="text-gray-700 mt-6 max-w-3xl mx-auto text-lg">
          Farming is tough enough without worrying about technology failures.  
          Our helpdesk ensures you never feel stuck or left behind. With us as your  
          co-pilot, every challenge feels easier, and every solution is just a call away.
        </p>
        <p className="mt-6 text-xl font-semibold text-green-700">
          “We are your extended team - always ready to help,  
          so your drone keeps flying and your work never slows down.”
        </p>
      </section>
     </>
  );
};

export default Helpdesk;
